import { createSlice } from '@reduxjs/toolkit';
import { DoctorSchedulerState } from '../types/types';

const initialDoctorScheduler: DoctorSchedulerState = {
  days: []
};

// const ecTime = (date: string) => new Date(date).toLocaleString();

const doctorSchedulerSlice = createSlice({
  name: 'doctorScheduler',
  initialState: initialDoctorScheduler,
  reducers: {
    addDay(state, action) {
      state.days = [action.payload, ...state.days];
    },
    deleteDay(state, action) {
      state.days = action.payload;
    }
  }
});

export const doctorSchedulerActions = doctorSchedulerSlice.actions;

export default doctorSchedulerSlice.reducer;
